/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Address of the coproperty (created with it). The point (registry or Google) feeds the terrain estimation; the back falls back to the RNIC coordinates when absent.
 * @export
 * @interface CopropertyAddressCommand
 */
export interface CopropertyAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressCommand
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressCommand
     */
    line2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressCommand
     */
    line3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressCommand
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressCommand
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressCommand
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressCommand
     */
    formattedAddress?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyAddressCommand
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CopropertyAddressCommand
     */
    longitude?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CopropertyAddressCommand
     */
    googlePlaceId?: string | null;
}

/**
 * Check if a given object implements the CopropertyAddressCommand interface.
 */
export function instanceOfCopropertyAddressCommand(value: object): value is CopropertyAddressCommand {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function CopropertyAddressCommandFromJSON(json: any): CopropertyAddressCommand {
    return CopropertyAddressCommandFromJSONTyped(json, false);
}

export function CopropertyAddressCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopropertyAddressCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'line3': json['line3'] == null ? undefined : json['line3'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'googlePlaceId': json['googlePlaceId'] == null ? undefined : json['googlePlaceId'],
    };
}

export function CopropertyAddressCommandToJSON(json: any): CopropertyAddressCommand {
    return CopropertyAddressCommandToJSONTyped(json, false);
}

export function CopropertyAddressCommandToJSONTyped(value?: CopropertyAddressCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line1': value['line1'],
        'line2': value['line2'],
        'line3': value['line3'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'formattedAddress': value['formattedAddress'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'googlePlaceId': value['googlePlaceId'],
    };
}

